import React from 'react';
import { connect } from 'react-redux';
import { find, isEqual, capitalize, cloneDeep, get, sumBy } from 'lodash';
import ReactTable from "react-table";
import Box from '../../common/Box';
import ModeSelect from '../../common/ModeSelect';
import ReactSelect from '../../common/ReactSelect';
import WorldMap from '../../common/WorldMap';
import LineChart from '../../widgets/charts/types/LineChart';
import LineChartWithAnnotations from '../../widgets/charts/types/LineChartWithAnnotations';
import DateGroupSelector from '../result/DateGroupSelector';
import CSV from '../../../helpers/CSVExport';
import YoutubeTerritoriesMap from './YoutubeTerritories/Map';
import { territorySettings } from './YoutubeTerritories/Settings'; 
import cellHeaderHOC from '../../common/Datagrid/CellHeaderHOC';

const CellHeaderTable = cellHeaderHOC(ReactTable);

import { youtubeActions } from '../../../data/actions/youtube';
var downloadSvg = require('!svg-inline-loader!../../../../public/img/download.svg');
var worldSvg = require('!svg-inline-loader!../../../../public/img/world.svg');
var lineSvg = require('!svg-inline-loader!../../../../public/img/line.svg');
var tableSvg = require('!svg-inline-loader!../../../../public/img/table.svg');

class YoutubeTerritories extends React.Component {
	
	nullElement = {vend_id: 0, value: 'all', label: 'All'}
	
	constructor(props) {
		super(props);
		this.state = {
			vendor: this.nullElement,
			mode: props.defaultMode || 'map',
			view: 'views',
			dateGroup: null,
			sorted: [{id: 'total', desc: true}]
		}
		
		this.setVendor = this.setVendor.bind(this);
		this.setView = this.setView.bind(this);
		this.setDateGroup = this.setDateGroup.bind(this);
		this.exportToCsv = this.exportToCsv.bind(this);
		this.setChartMode = this.setChartMode.bind(this);
	}

	setVendor(vendor) {
		this.setState({vendor});
	}

	setDateGroup(dateGroup) {
        this.setState({dateGroup}, ()=>{
            this.props.getYoutubeTerritoriesTimeseries(this.props.filtered, this.state.sorted, this.state.dateGroup);
        });
    }

	setView({value}) {
		this.setState({view: value});
	}
	
	setChartMode(mode){
		this.setState({mode});
		
		const { modeChange } = this.props;
		if(typeof modeChange == 'function')
			modeChange(mode);
			
		if(mode == 'line') {
			this.props.getYoutubeTerritoriesTimeseries(this.props.filtered, this.state.dateGroup);
		}
	}
	
	renderToolbar(data){
		let toolbar = [];
		const options = [
			{icon: worldSvg, value: 'map', label: "World Map"},
			{icon: tableSvg, value: 'table', label: "Table"},
		];
		toolbar.push(<div key="wrapper" className="ibox-action-wrapper">
		<div className="ibox-icon-holder mode-select">
			<ModeSelect options={options} selected={this.state.mode} onChange={this.setChartMode} isSearchable={ false } />
		</div>
		<div className="ibox-actions">
			<a key="download" title="Export CSV" onClick={this.exportToCsv} className="download-link" dangerouslySetInnerHTML={{__html: downloadSvg}} />	
		</div>
		</div>)
		return toolbar;
	}
	
    exportToCsv(){
		const {table} = this.props.youtube.territory;
        const filename = CSV.CSVHeader('youtube_territories', '', this.props.filter.global, this.props.parentEntityTitle); 
        return CSV.CSVExport(table, {filename}, 'youtube_territories');
    }

	
	
	componentDidMount() {
		this.props.getYoutubeTerritories(this.props.filtered, this.state.sorted, this.state.dateGroup);
		const { mode } = this.state;
		if(mode == 'line') {
			this.props.getYoutubeTerritoriesTimeseries(this.props.filtered, this.state.sorted, this.state.dateGroup);
		}
	}
	
	componentWillReceiveProps(nextProps){
		if(nextProps.filter && nextProps.filter.global){
			if(this.props.filter.global!==undefined && !isEqual(nextProps.filter.global, this.props.filter.global)) {
				this.props.getYoutubeTerritories(this.props.filtered, this.state.sorted, this.state.dateGroup);
				const { mode } = this.state;
				if(mode == 'line')
					this.props.getYoutubeTerritoriesTimeseries(this.props.filtered, this.state.sorted, this.state.dateGroup);

			}                
		}
		if(nextProps.filtered && !isEqual(nextProps.filtered, this.props.filtered)) {
			this.props.getYoutubeTerritories(nextProps.filtered, this.state.sorted, this.state.dateGroup);
		} 
	}
	
    renderChartActions(data){
        const { mode } = this.state;
        let vendors = [this.nullElement];
        if(data) {
            for(let vendor of data) {
                vendors.push(vendor);
            }
        }
          
        return <React.Fragment>
			<div className="entity-selector-select">
			    <ReactSelect value={this.state.vendor} options={vendors} onChange={this.setVendor} className="single-select"/>    
			</div>
            {mode == 'line' && <DateGroupSelector dateGroupChange={this.setDateGroup}/>}
        </React.Fragment>
    }
	
	render (){  
		const {territoryLoading, territory, youtubeTerritoriesTimeseries, youtubeTerritoriesTimeseriesLoading} = this.props.youtube,
			widgetTitle = `Top YouTube Territories`;
		const { view, vendor, mode } = this.state;
		
		let { shadowChartProps } = this.props;
		if(shadowChartProps){
			shadowChartProps.shadowChart = true;
		}    
		
		const mapHolderClass = mode === 'map' ? 'world-map-container single-map' : 'map-table-container';
		
		return <Box title={widgetTitle} toolbar={this.renderToolbar()} spinnerEnabled={(territoryLoading || youtubeTerritoriesTimeseriesLoading)} className="territories-widget" >
		{territory && <div className="territory-map-row">
			<div className={`territory-details-map`}>
				<div className={`chart-block chart-block--full custom-scroll ${mapHolderClass}`}>
					{mode == 'map' && <YoutubeTerritoriesMap data={territory.table} label="units" view={view} />}
					{mode=='table' && <div className="territory-table territory-table--single custom-scroll"><CellHeaderTable
						className="simple-table"
							data={territory.table}
							columns={territorySettings.settingsForTable(view)}
							defaultPageSize={10}
							showPagination={territory.length > 10}
							noDataText='No results found. Please check your filters.'
					/>
					</div>}
				</div>
			</div>
		</div>}
		</Box>;
	}
}

function mapStateToProps(state) {
	return {
		stats: state.stats,
	} 
}

function mapStateToProps(state) {
	return {
		youtube: state.youtube,
		filter: state.filter,
		milestones: state.milestones
	} 
}

function mapDispatchToProps(dispatch, ownProps) {
	return {
		getYoutubeTerritories: (filtered, sorted) => {
			return dispatch(youtubeActions.getTerritoryStats(filtered, sorted));
		} ,
		
		getYoutubeTerritoriesTimeseries: (filtered, sorted, dateGroup) => {
			return dispatch(youtubeActions.getTerritoryStats(filtered, sorted, dateGroup));
		} 
	} 
}



export default connect(mapStateToProps, mapDispatchToProps)(YoutubeTerritories);